import React, { Component } from "react";

export default class Title extends Component {

    render() {
        return (
            <div className="SidePanel-root">
                <div className="SidePanel-subtitle">
                    Makes the Best Matches!
                </div>
            </div>
        );
    }

}